<md-page-title value="md-info-box | Info box"></md-page-title>

<div class="flex direction-column gap-4 p-3">

  <md-info-box value="Example info box"></md-info-box>

  <md-info-box [value]="longText"> </md-info-box>
</div>
